export const MAX_LEVEL = 6;
export const SPECIAL_NODE_NAME_LIST = [
    'undefined',
    '待确定',
    '待確定',
    '確定待ち',
    'blank',
    '空白',
    '空の',
];
export const MAX_LAYER_NODE_LENGTH = 1200;
export const MAX_OPTION_NODE_LENGTH = 1200;
/**
 * chemical移除的字段
 */
export const CHEMICAL_REMOVED_FIELDS = ['CHEMICAL_STRUCTURE'];
